.page-title {
	max-width: em(1100px);
	margin: $section-spacing auto $section-spacing--lg / 2;
	@media(min-width:break($_s)){
		margin: $section-spacing--lg auto $section-spacing--lg / 2;
	}
}
